/** Etiquetas UI — Clientes: XML en sistema vs descarga SAT (sin lógica SAT). */

export const CLIENT_XML_SISTEMA_LABELS = {
  sectionEstado: "Estado SAT del cliente",
  sectionXml: "XML disponibles en sistema",
  descargarXmlSistema: "Descargar XML del sistema",
  exportarZipPendiente: "Generar ZIP de XML guardados — pendiente de conectar desde Clientes",
  verMonitor: "Ver estado detallado",
  gestionarXml: "Exportar XML guardados (Gestión XML)",
};

export function formatClientSatTimestamp(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(String(iso).replace("Z", "+00:00"));
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function formatSyncAutoLabel(activo) {
  return activo ? "Activada" : "Desactivada";
}

/** Etiqueta informativa del scheduler/robot para este cliente (sin llamar al robot). */
export function formatSchedulerClienteLabel(client) {
  if (!client) return "—";
  if (!client.modulo_descarga_activo) {
    return "Inactivo en este cliente (sync automática desactivada)";
  }
  const st = String(client.estado_sincronizacion || "").trim().toLowerCase();
  if (st === "procesando") return "Activo — sincronización en curso";
  if (st === "pendiente") return "Activo — en cola del scheduler";
  if (st === "completado" || client.sat_sync_historical_complete) {
    return "Activo — al corriente";
  }
  if (st === "error" || st === "fiel") return "Pausado — revisar credenciales o estado";
  return "Programado por scheduler";
}

export function formatPeriodoCubiertoLabel(client) {
  const from = (client?.sat_sync_target_from || "").slice(0, 10);
  const to = (client?.sat_sync_target_to || "").slice(0, 10);
  if (from && to) return `${from} → ${to}`;
  if (to) return `Hasta ${to}`;
  if (from) return `Desde ${from}`;
  if (client?.sat_sync_historical_complete || client?.has_local_cfdis) {
    return "Con XML integrados (sin rango declarado)";
  }
  return "—";
}

export function syncEstadoColaLabel(estado) {
  const st = String(estado || "").trim().toLowerCase();
  const map = {
    procesando: "Procesando",
    pendiente: "Pendiente",
    completado: "Al corriente",
    error: "Error",
    fiel: "FIEL / credenciales",
    portal: "Esperando portal SAT",
  };
  return map[st] || (st || "—");
}

export function sumCfdiSummaryByDireccion(summaryRows) {
  const rows = Array.isArray(summaryRows) ? summaryRows : [];
  let emitido = 0;
  let recibido = 0;
  for (const row of rows) {
    const n = Number(row?.count) || 0;
    const d = String(row?.direccion || "").trim().toLowerCase();
    if (d === "emitido") emitido += n;
    else if (d === "recibido") recibido += n;
  }
  return { emitido, recibido };
}
